export const DEM_SOURCE_CITATIONS = {
    lidar_usgs: {
        provider: 'U.S. Geological Survey (USGS) — distributed by OpenTopography',
        datasetName: 'USGS 3DEP Digital Elevation Model',
        citation: 'U.S. Geological Survey (USGS) Digital Elevation Models (DEMs) — USGS National Map 3DEP Downloadable Data Collection. Accessed via the OpenTopography Facility with support from the National Science Foundation under NSF Award Numbers EAR-1948997, EAR-1948994 & EAR-1948857.',
        license: 'USGS data is in the public domain (U.S. Government work). Distribution provided by OpenTopography with NSF support; please retain attribution in derivative products.',
        attribution: 'Elevation data: U.S. Geological Survey, 3D Elevation Program (3DEP). Distributed by OpenTopography with support from the U.S. National Science Foundation.',
        link: 'https://www.usgs.gov/3d-elevation-program',
        isSystemSourced: true,
    },
    lidar_opentopo: {
        provider: 'OpenTopography',
        datasetName: 'OpenTopography-hosted LiDAR / DEM',
        citation: 'Data accessed via the OpenTopography Facility with support from the National Science Foundation under NSF Award Numbers EAR-1948997, EAR-1948994 & EAR-1948857. Cite the specific dataset DOI where available.',
        license: 'Per the dataset-specific OpenTopography license. Refer to the dataset page or DOI for usage terms.',
        attribution: 'Elevation data accessed via OpenTopography with support from the U.S. National Science Foundation.',
        link: 'https://opentopography.org',
        isSystemSourced: true,
    },
    nrcan_hrdem: {
        provider: 'Natural Resources Canada (NRCan)',
        datasetName: 'HRDEM — High Resolution Digital Elevation Model (CanElevation Series)',
        citation: 'High Resolution Digital Elevation Model (HRDEM) — CanElevation Series. © Department of Natural Resources Canada. Derived from airborne LiDAR (1 m DTM).',
        // OGL-Canada-2.0 required attribution statement (verbatim) + provider credit.
        license: 'Contains information licensed under the Open Government Licence – Canada. © Natural Resources Canada.',
        link: 'https://open.canada.ca/data/en/dataset/957782bf-847c-4644-a757-e383c0057995',
        licenseLink: 'https://open.canada.ca/en/open-government-licence-canada',
        resolutionMeters: 1,
        isSystemSourced: true,
    },
    linz: {
        provider: 'Toitū Te Whenua Land Information New Zealand (LINZ)',
        datasetName: 'New Zealand LiDAR 1m DEM (DTM)',
        citation: 'New Zealand LiDAR 1m Digital Elevation Model — sourced from Toitū Te Whenua Land Information New Zealand (LINZ).',
        // CC BY 4.0 requires crediting LINZ, indicating the licence, and linking it.
        license: 'Sourced from Toitū Te Whenua Land Information New Zealand. Licensed for reuse under the Creative Commons Attribution 4.0 International licence (CC BY 4.0).',
        link: 'https://data.linz.govt.nz/layer/121859-new-zealand-lidar-1m-dem/',
        licenseLink: 'https://creativecommons.org/licenses/by/4.0/',
        resolutionMeters: 1,
        isSystemSourced: true,
    },
    uk_ea: {
        provider: 'Environment Agency (England)',
        datasetName: 'LIDAR Composite DTM 1m (National LIDAR Programme)',
        citation: 'LIDAR Composite Digital Terrain Model (DTM) 1m — Environment Agency, England. Derived from the National LIDAR Programme and Time Stamped survey archive.',
        // OGL v3 required attribution statement + provider credit.
        license: 'Contains public sector information licensed under the Open Government Licence v3.0. © Environment Agency copyright and/or database right.',
        link: 'https://environment.data.gov.uk/dataset/13787b9a-26a4-4775-8523-806d13af58fc',
        licenseLink: 'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/',
        resolutionMeters: 1,
        isSystemSourced: true,
    },
    swisstopo: {
        provider: 'Federal Office of Topography swisstopo',
        datasetName: 'swissALTI3D 0.5m Digital Terrain Model',
        citation: 'swissALTI3D — Federal Office of Topography swisstopo. High-precision 0.5m digital terrain model of Switzerland.',
        license: 'Free open government data (swisstopo). Commercial use permitted; source reference (© swisstopo) required.',
        attribution: 'Source: Federal Office of Topography swisstopo. © swisstopo.',
        link: 'https://www.swisstopo.admin.ch/en/height-model-swissalti3d',
        licenseLink: 'https://www.swisstopo.admin.ch/en/terms-of-use-free-geodata-and-geoservices',
        resolutionMeters: 0.5,
        isSystemSourced: true,
    },
    nl_ahn: {
        provider: 'Actueel Hoogtebestand Nederland (AHN) / PDOK',
        datasetName: 'AHN 0.5m Digital Terrain Model',
        citation: 'Actueel Hoogtebestand Nederland (AHN) — the national 0.5m LiDAR digital terrain model of the Netherlands, via PDOK.',
        license: 'Public domain under Creative Commons Zero (CC0 1.0). Free for any use, including commercial; no attribution required (credit to AHN appreciated).',
        attribution: 'Source: Actueel Hoogtebestand Nederland (AHN), via PDOK. Public domain (CC0 1.0).',
        link: 'https://www.ahn.nl/',
        licenseLink: 'https://creativecommons.org/publicdomain/zero/1.0/',
        resolutionMeters: 0.5,
        isSystemSourced: true,
    },
    no_kartverket: {
        provider: 'Kartverket (Norwegian Mapping Authority)',
        datasetName: 'National Height Model (DTM) 1m',
        citation: 'National Height Model (Nasjonal høydemodell) 1m DTM — Kartverket, Norway (Høydedata).',
        license: 'Open data, free for commercial and non-commercial use under Kartverket / Norwegian open data terms.',
        attribution: 'Source: Kartverket (Norwegian Mapping Authority), Høydedata.',
        link: 'https://hoydedata.no/',
        licenseLink: 'https://www.kartverket.no/en/api-and-data/terms-of-use',
        resolutionMeters: 1,
        isSystemSourced: true,
    },
    dgt_mdt: {
        provider: 'Direção-Geral do Território (DGT), Portugal',
        datasetName: 'MDT 0.5m — Levantamento LiDAR de Portugal',
        citation: 'Modelo Digital do Terreno (MDT) 0.5m — Levantamento LiDAR de Portugal Continental, Direção-Geral do Território (DGT).',
        license: 'Owner: Direção-Geral do Território (DGT). Licensed for reuse under the Creative Commons Attribution 4.0 International licence (CC BY 4.0).',
        link: 'https://cdd.dgterritorio.gov.pt/',
        licenseLink: 'https://creativecommons.org/licenses/by/4.0/',
        resolutionMeters: 0.5,
        isSystemSourced: true,
    },
    scotland_srsp: {
        provider: 'Scottish Government / Scottish Remote Sensing Portal',
        datasetName: 'Scottish Public Sector LiDAR DTM',
        citation: 'Scottish Public Sector LiDAR — Scottish Government, via the Scottish Remote Sensing Portal. Bare-earth DTM (best available resolution per area).',
        // OGL v3 required attribution statement + provider credit.
        license: 'Contains public sector information licensed under the Open Government Licence v3.0. © Scottish Government and partners.',
        link: 'https://remotesensingdata.gov.scot/',
        licenseLink: 'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/',
        isSystemSourced: true,
    },
    wales_dmw: {
        provider: 'Welsh Government / DataMapWales',
        datasetName: 'Welsh Government LiDAR DTM (2020-2023)',
        citation: 'National LiDAR Programme for Wales — Welsh Government, via DataMapWales. Bare-earth DTM at 1 m resolution.',
        // OGL v3 required attribution statement + provider credit.
        license: 'Contains public sector information licensed under the Open Government Licence v3.0. © Welsh Government.',
        link: 'https://datamap.gov.wales/maps/lidar-viewer/',
        licenseLink: 'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/',
        resolutionMeters: 1,
        isSystemSourced: true,
    },
    ign_lidarhd: {
        provider: 'IGN — Institut national de l’information géographique et forestière',
        datasetName: 'LiDAR HD — Modèle Numérique de Terrain (MNT 0.5 m)',
        citation: 'LiDAR HD — Modèle Numérique de Terrain (MNT) 0.5 m, IGN, via la Géoplateforme. Bare-earth DTM.',
        license: 'Données IGN diffusées sous Licence Ouverte / Open Licence 2.0 (Etalab). © IGN.',
        link: 'https://geoservices.ign.fr/lidarhd',
        licenseLink: 'https://www.etalab.gouv.fr/licence-ouverte-open-licence/',
        resolutionMeters: 0.5,
        isSystemSourced: true,
    },
    ign_rgealti: {
        provider: 'IGN — Institut national de l’information géographique et forestière',
        datasetName: 'RGE ALTI® (MNT 1 m)',
        citation: 'RGE ALTI® 1 m — Modèle Numérique de Terrain, IGN, via la Géoplateforme. National bare-earth DTM.',
        license: 'Données IGN diffusées sous Licence Ouverte / Open Licence 2.0 (Etalab). © IGN.',
        link: 'https://geoservices.ign.fr/rgealti',
        licenseLink: 'https://www.etalab.gouv.fr/licence-ouverte-open-licence/',
        resolutionMeters: 1,
        isSystemSourced: true,
    },
    at_bev: {
        provider: 'BEV — Bundesamt für Eich- und Vermessungswesen (Austria)',
        datasetName: 'ALS Digitales Geländemodell 1m (Austria)',
        citation: 'Airborne Laserscan Digitales Geländemodell (ALS DTM) 1m, BEV — Bundesamt für Eich- und Vermessungswesen, via data.bev.gv.at. National bare-earth DTM.',
        license: 'Data: © BEV — data.bev.gv.at, licensed under Creative Commons Attribution 4.0 International (CC BY 4.0).',
        link: 'https://www.bev.gv.at/Services/Produkte/Digitales-Gelaendehoehenmodell/ALS-Hoehenraster.html',
        licenseLink: 'https://creativecommons.org/licenses/by/4.0/',
        resolutionMeters: 1,
        isSystemSourced: true,
    },
    ie_gsi: {
        provider: 'Geological Survey Ireland (GSI) & partners',
        datasetName: 'Open Topographic LiDAR DTM (Ireland)',
        citation: 'Open Topographic LiDAR Digital Terrain Model, Geological Survey Ireland and partners (OPW, TII, NYU, county councils), via gsi.geodata.gov.ie. Bare-earth DTM (coverage is a multi-agency patchwork).',
        license: 'Contains Irish Public Sector Data (Geological Survey Ireland) licensed under a Creative Commons Attribution 4.0 International (CC BY 4.0) licence.',
        link: 'https://www.gsi.ie/en-ie/data-and-maps/Pages/Geophysics.aspx',
        licenseLink: 'https://creativecommons.org/licenses/by/4.0/',
        resolutionMeters: 1,
        isSystemSourced: true,
    },
    uy_ideuy: {
        provider: 'IDEuy — Infraestructura de Datos Espaciales del Uruguay (AGESIC)',
        datasetName: 'Modelo Digital del Terreno 2.5 m (Uruguay)',
        citation: 'Modelo Digital del Terreno (MDT) 2.5 m de cobertura nacional, IDEuy — Infraestructura de Datos Espaciales del Uruguay, via visualizador.ide.uy. National bare-earth DTM.',
        license: 'Datos publicados bajo la Licencia de Datos Abiertos de Gobierno (DAG) del Uruguay (Ley N.º 19.355, art. 82). © IDEuy / AGESIC.',
        link: 'https://visualizador.ide.uy/',
        licenseLink: 'https://catalogodatos.gub.uy/pages/dag',
        resolutionMeters: 2.5,
        isSystemSourced: true,
    },
    user_upload: {
        provider: 'User-provided',
        datasetName: 'Uploaded DEM',
        citation: 'DEM uploaded by the project owner. The uploader is responsible for documenting source and licensing.',
        license: 'Project owner attests to having rights to use this data.',
        link: '',
        isSystemSourced: false,
    },
    admin_upload: {
        provider: 'Administrator-provided',
        datasetName: 'Uploaded DEM',
        citation: 'DEM provided by a Landscope administrator. Source documentation maintained internally.',
        license: 'Internal sourcing — attribution per the originating dataset.',
        link: '',
        isSystemSourced: false,
    },
};
// A stored source type that the registry knows, or null (a project that has not
// been processed yet, or a type this client predates).
export const resolveDemSourceType = (type) => type && Object.prototype.hasOwnProperty.call(DEM_SOURCE_CITATIONS, type) ? type : null;
export const isSystemSourcedType = (type) => {
    var _a, _b;
    if (!type)
        return false;
    return (_b = (_a = DEM_SOURCE_CITATIONS[type]) === null || _a === void 0 ? void 0 : _a.isSystemSourced) !== null && _b !== void 0 ? _b : false;
};
